/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
	  };
import type * as Types from '../../../../../gql/types-mutations';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetHeniNewsArticlesQueryVariables = Exact<{
	artistName?: string | null | undefined;
	geotagName?: string | null | undefined;
	categoryName?: string | null | undefined;
	visibility?: string | null | undefined;
	limit: number;
	offset: number;
	publishDateFrom?: Types.DateFilter | null | undefined;
	isHeni?: boolean | null | undefined;
}>;

export type GetHeniNewsArticlesQuery = {
	getArticles: Array<{
		attribution: string | null;
		contentLang: string | null;
		date_created: any;
		date_updated: any;
		publishDate: any;
		description: string | null;
		domain: string | null;
		globalCategory: string | null;
		id: string;
		title: string | null;
		url: string | null;
		categories: Array<{
			HENI_News_Categories_id: { id: string; name: string } | null;
		} | null> | null;
		geotag: { id: string; name: string } | null;
		image: {
			height: number | null;
			width: number | null;
			filename_disk: string | null;
		} | null;
		artists: Array<{
			HENI_News_Artists_id: { id: string; name: string } | null;
		} | null> | null;
	} | null>;
};

export const GetHeniNewsArticlesDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'getHeniNewsArticles' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'artistName' },
					},
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'geotagName' },
					},
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'categoryName' },
					},
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'visibility' },
					},
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'limit' },
					},
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'offset' },
					},
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'publishDateFrom' },
					},
					type: {
						kind: 'NamedType',
						name: { kind: 'Name', value: 'DateFilter' },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'isHeni' },
					},
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'getArticles' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'artistName' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'artistName' },
								},
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'geotagName' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'geotagName' },
								},
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'categoryName' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'categoryName' },
								},
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'visibility' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'visibility' },
								},
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'limit' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'limit' },
								},
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'offset' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'offset' },
								},
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'publishDateFrom' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'publishDateFrom' },
								},
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'isHeni' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'isHeni' },
								},
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'attribution' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'categories' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: {
													kind: 'Name',
													value: 'HENI_News_Categories_id',
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'id' },
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'name' },
														},
													],
												},
											},
										],
									},
								},
								{ kind: 'Field', name: { kind: 'Name', value: 'contentLang' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'date_created' },
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'date_updated' },
								},
								{ kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'domain' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'geotag' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'name' } },
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'globalCategory' },
								},
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'image' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'height' },
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'filename_disk' },
											},
										],
									},
								},
								{ kind: 'Field', name: { kind: 'Name', value: 'publishDate' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'artists' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'HENI_News_Artists_id' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'id' },
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'name' },
														},
													],
												},
											},
										],
									},
								},
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetHeniNewsArticlesQuery,
	GetHeniNewsArticlesQueryVariables
>;
